import React, { createContext, useEffect, useState } from 'react';

export const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
    const [sessionActive, setSessionActive] = useState(() => {
        return localStorage.getItem('sessionActive') === 'true';
    });

    const userRole = localStorage.getItem('empRole'); // Retrieve the user role from localStorage
    const excludedRoles = ['100', '101', '1', '5', '6']; // List of roles to be excluded

    const handleTimeout = () => {
        setSessionActive(false);
        localStorage.setItem('sessionActive', 'false');
        
        // Handle logout logic here
        alert('Session Logout');
        localStorage.clear();
        window.location.href = '/'; // Navigate to the URL
    };

    const resetTimeout = () => {
        
        if (sessionActive && !excludedRoles.includes(userRole)) {
            clearTimeout(window.sessionTimeout);
            window.sessionTimeout = setTimeout(handleTimeout, 2 * 60 * 60 * 1000); // 2 hours 
            // window.sessionTimeout = setTimeout(handleTimeout, 2 * 60 * 1000); // 2 minutes
        }
    };

    useEffect(() => {
        if (!excludedRoles.includes(userRole)) {
        resetTimeout();

        const events = ['mousemove', 'keydown', 'click', 'touchstart', 'touchmove', 'touchend'];
        events.forEach(event => window.addEventListener(event, resetTimeout));

        return () => {
            events.forEach(event => window.removeEventListener(event, resetTimeout));
            clearTimeout(window.sessionTimeout);
        };
    }
    }, [sessionActive, userRole]);

    return (
        <SessionContext.Provider value={{ sessionActive, setSessionActive }}>
            {children}
        </SessionContext.Provider>
    );
};
